import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import {
  getPathnameMyResourcesDetails,
  PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID,
  PATH_MY_RESOURCES
} from "../paths";
import { useQueryInsuranceCoverages } from "../../../query/insuranceCoverage/queries/useQueryInsuranceCoverages";
import { WSQueries } from "../../../query/WSQuery";
import { useQueriesOn } from "../../../shared/hooks/useQueriesOn";

export const RouteMyRedirectFromEnrollmentToDetails: React.FC<
  RouteComponentProps<
    {
      [PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID]: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = props => {
  const qInsuranceCoverages = useQueryInsuranceCoverages(
    {
      filter: {
        sourceId: props.match.params.planEnrollmentId
      },
      page: {
        size: 2
      },
      sort: "createdAt"
    },
    {
      retry: false
    }
  );

  useQueriesOn(
    "error",
    () => {
      props.history.push(PATH_MY_RESOURCES);
    },
    qInsuranceCoverages
  );

  return (
    <WSPage>
      <WSQueries queries={{ qInsuranceCoverages }}>
        {({ qInsuranceCoveragesData }) => {
          const insurances = qInsuranceCoveragesData.pages[0];

          if (insurances.length === 1) {
            return (
              <Redirect
                to={getPathnameMyResourcesDetails(
                  "",
                  insurances[0].insuranceCoverageId
                )}
              />
            );
          }

          return <Redirect to={PATH_MY_RESOURCES} />;
        }}
      </WSQueries>
    </WSPage>
  );
};
